// Строка под кнопкой отправки, когда форма не готова. Общая для регистрации (SignUp.vue)
// и заявки на зал (hallForm.ts): одна формулировка на две формы. Текущее правило —
// music-coworking-spec.md, «Аренда зала», абзац про кнопку «Отправить заявку». Закрытая
// спека 2026-10-14-owner-ux-polish (п.3) — история: там капча ещё пряталась за полями.
// Оба провайдера капчи рисуют галочку «я не робот», которую человек жмёт сам, поэтому
// строка просит действие, а не обещает проверить. Капча не прячется за полями: человек
// видит сразу всё, что осталось сделать.
export const CAPTCHA_HINT = 'Подтвердите, что вы не робот'

// Пустые поля — «заполните», заполненные, но не прошедшие проверку (повтор пароля, дата
// вне диапазона) — отдельной частью «Проверьте», иначе глагол врёт про заполненное поле.
export function submitHintText(missingLabels: string[], captchaPending: boolean, invalidLabels: string[] = []): string {
  const parts: string[] = []
  if (missingLabels.length) parts.push(`Чтобы отправить, заполните: ${missingLabels.join(', ')}`)
  if (invalidLabels.length) parts.push(`Проверьте: ${invalidLabels.join(', ')}`)
  if (captchaPending) parts.push(CAPTCHA_HINT)
  return parts.join('. ')
}
